import { FC } from 'react'
import { QuestionnaireItem } from '@medplum/fhirtypes'
import { Typography } from 'antd'
import {
  MultiSelectQuestion,
  QuestionLayout,
  TextAreaQuestion
} from 'components/Assessments/components/QuestionComponents'
import { useAssessmentContext } from 'contexts/AssessmentContext'
import { ALL_DOCUMENT_TYPES_AND_CODES } from 'components/Assessments/constants'
import { RocAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { RocFormField } from '../../types/RocFormField'
const { Text } = Typography

interface FinalStepsSectionProps {
  section: QuestionnaireItem
}

const documentTypesOptions = Object.keys(ALL_DOCUMENT_TYPES_AND_CODES).map((type) => ({
  value: type,
  label: ALL_DOCUMENT_TYPES_AND_CODES[type].label,
  coding: {
    display: ALL_DOCUMENT_TYPES_AND_CODES[type].label,
    code: ALL_DOCUMENT_TYPES_AND_CODES[type].code
  }
}))

const FinalStepsSection: FC<FinalStepsSectionProps> = ({ section }) => {
  const { cantEditAssessmentFields, assessmentMustBeFinalized } = useAssessmentContext()
  const pendingRequiredDocumentationItem = section.item?.find(
    (item) =>
      item.linkId === RocAssessmentQuestionnaireItem.FINAL_STEPS_PENDING_REQUIRED_DOCUMENTATION
  )
  const internalNotesItem = section.item?.find(
    (item) => item.linkId === RocAssessmentQuestionnaireItem.FINAL_STEPS_INTERNAL_NOTES
  )

  return (
    <div>
      <Text type="secondary">
        {section.extension?.[0]?.valueCodeableConcept?.coding?.[0]?.display}
      </Text>
      {pendingRequiredDocumentationItem && (
        <MultiSelectQuestion
          field={pendingRequiredDocumentationItem}
          formFieldName={RocFormField.PENDING_REQUIRED_DOCUMENTATION}
          layout={QuestionLayout.HORIZONTAL}
          disabled={cantEditAssessmentFields}
          required={assessmentMustBeFinalized}
          customOptions={documentTypesOptions}
        />
      )}
      {internalNotesItem && (
        <TextAreaQuestion
          field={internalNotesItem}
          formFieldName={RocFormField.INTERNAL_NOTES}
          layout={QuestionLayout.HORIZONTAL}
          disabled={cantEditAssessmentFields}
          required={assessmentMustBeFinalized}
          rows={4}
          disabledResize
        />
      )}
    </div>
  )
}

FinalStepsSection.displayName = 'FinalStepsSection'

export default FinalStepsSection
